$(document).foundation();

$(document).ready(function() {
	initWelcome();
	initLanguages();
	initPlayer();
});

var playerDataOffset = 0;


function initWelcome() {
	$('.welcome__start button').on('click', function () {
		$('.welcome__instructions').show();
		animateInstructions();
	});
	
	$('.welcome__instructions-back button').on('click', function () {
		$('.welcome__instructions').fadeOut(function () {
			unanimateInstructions();
		});
	});
}



function animateInstructions() {
	var delay = 500;
	$('.instructions li').each(function () {
		
		var $instructionStep = $(this);		
		setTimeout(function () {
			$instructionStep.addClass('visible');
		}, delay);
		
		delay += 1000;
	});
}

function unanimateInstructions() {
	$('.instructions li').removeClass('visible');
}


function initPlayer() {
	if ( $('.player').length === 0 ) return;
	
	if ( typeof playerData === 'undefined' ) {
		alert('No audio files');
		return;
	}
	
	if ( typeof playerDataStartsAtZero !== 'undefined' ) {
		playerDataOffset = playerDataStartsAtZero ? 1 : 0; // If the player data starts at 0 then always add 1 for the calculated value
	}
	
	
	setInterval(refreshPlayer, 1000);
	refreshPlayer();
	
	
	// Check for URL hash from QR code links
	if ( window.location.hash !== '' ) {
		autoLoadFromHash();
	}
	
	
	// Number input & validation
	$('.player__keypad-number').on('click', function () {
		$('.player__title h1').html('&nbsp;');
		
		var newNumber = $('.player__track').text() + $(this).text();
		$('.player__track').text( newNumber );
		
		var newNumberInt = parseInt(newNumber, 10);
		if ((newNumberInt === 0) && (!playerDataStartsAtZero)) return;
		
		if ( (newNumberInt <= playerData.length) && ((newNumberInt > 0) || (playerDataStartsAtZero)) ) {
			// Valid track number
			$('.player__title h1').text( decodeEntities(playerData[newNumberInt - 1 + playerDataOffset]["Title"]) );
			$('.player__track').text( newNumberInt );
		} else {
			// Not valid track number so wiggle the display and reject the input
			$('.player__track').addClass('player__track--incorrect');
			setTimeout(function () {
				$('.player__track').removeClass('player__track--incorrect');
				$('.player__track').text( newNumber.substring(0, newNumber.length - 1) );
			}, 700);
		}
		
		setPlayerStatus('ready');
	});
	
	$('.player__keypad-delete').on('click', function () {
		var currentNumber = $('.player__track').text();
		var newNumber = currentNumber.substring(0, currentNumber.length - 1);
		if ( newNumber == '' ) {
			$('.player__title h1').html( '&nbsp;' );
			$('.player__track').html( '&nbsp;' );
			setPlayerStatus('default');
		} else {
			$('.player__title h1').text( decodeEntities(playerData[newNumber - 1 + playerDataOffset]["Title"]) );
			$('.player__track').text( newNumber );
			setPlayerStatus('ready');
		}
	});
	
	
	
	
	
	
	// Instructions overlay
	$('.player__header-instructions button').on('click', function () {
		$('.player__instructions').show();
		animateInstructions();
	});
	
	$('.player__instructions').on('click', function () {
		$('.player__instructions').fadeOut();
		unanimateInstructions();
	});
	
	
	
	// Playback controls 
	$('.player__controls-play').on('click', function () {
		var player = $('#player')[0];
		
		if ( $('.player').hasClass('player--ready') ) {
			// Time to load the new track
			player.pause();
			var newTrack = parseInt($('.player__track').text(), 10);
			// Load the next mp3
			$('#player').attr('src', playerData[newTrack - 1 + playerDataOffset][returnCurrentLanguage()] );
			
			console.log(playerData[newTrack - 1 + playerDataOffset],returnCurrentLanguage());
			
			// Set the title to the next track
			$('.player__track').text( newTrack );
			$('.player__title h1').text( decodeEntities(playerData[newTrack - 1 + playerDataOffset]["Title"]) );
			player.load();
			player.play();
			setPlayerStatus('playing');
		} else {
			// User hasn't changed the track number so just toggle play/pause
			if ( player.paused ) {
				player.play();
				setPlayerStatus('playing');
			} else {
				player.pause();
				setPlayerStatus('paused');
			}
		}
	});
	
	
	
	$('.player__controls-prev').on('click', function () {
		var player = $('#player')[0];
		player.pause();
		
		var currentTrack = parseInt($('.player__track').text(), 10);
		var newTrack;
		
		if (currentTrack === 1) {
			newTrack = playerData.length;
		} else {
			newTrack = currentTrack - 1;
		}
		
		// Load the next mp3
		$('#player').attr('src', playerData[newTrack - 1 + playerDataOffset][returnCurrentLanguage()] );
		
		// Set the title to the next track
		$('.player__track').text( newTrack );
		$('.player__title h1').text( decodeEntities(playerData[newTrack - 1 + playerDataOffset]["Title"]) );
		
		player.load();
		player.play();
	});
	
	
	
	$('.player__controls-next').on('click', function () {
		var player = $('#player')[0];
		player.pause();
		
		var currentTrack = parseInt($('.player__track').text(), 10);
		var newTrack;
		
		if (currentTrack === playerData.length) {
			newTrack = 1;
		} else {
			newTrack = currentTrack + 1;
		}
		
		// Load the next mp3
		$('#player').attr('src', playerData[newTrack - 1 + playerDataOffset][returnCurrentLanguage()] );
		
		// Set the title to the next track
		$('.player__track').text( newTrack );
		$('.player__title h1').text( decodeEntities(playerData[newTrack - 1 + playerDataOffset]["Title"]) );
		
		player.load();
		player.play();
	});
	
	
	// Automatically queue up next track after completion, but don't play
	$('#player').on('onended', function () {
		var player = $('#player')[0];
		player.pause();
		
		var currentTrack = parseInt($('.player__track').text(), 10);
		var newTrack;
		
		if (currentTrack === playerData.length) {
			newTrack = 1;
		} else {
			newTrack = currentTrack + 1;
		}
		
		// Load the next mp3
		$('#player').attr('src', playerData[newTrack - 1 + playerDataOffset][returnCurrentLanguage()] );
		
		player.load();
		
		// Set the title to the next track
		$('.player__track').text( newTrack );
		$('.player__title h1').text( decodeEntities(playerData[newTrack - 1 + playerDataOffset]["Title"]) );
	});
}


function setPlayerStatus(status) {
	$('.player').attr('class', 'player');
	
	if (status == 'ready') {
		$('.player').addClass('player--ready');
	} else if (status == 'playing') {
		$('.player').addClass('player--playing');
	} else if (status == 'paused') {
		$('.player').addClass('player--paused');
	}
}


function refreshPlayer() {
	var player = $('#player')[0];
	
	// Update the time and duration values
	$('.player__timeline-elapsed').text( fancyTimeFormat(player.currentTime) );
	$('.player__timeline-length').text( fancyTimeFormat(player.duration) );
	
	// Move the progress bar
	var percentagePlayed = player.currentTime / player.duration * 100;
	$('.player__timeline-progress').css('width', percentagePlayed + '%');
	
	// Also move the elapsed time number, but not more than 90% to avoid overlapping the duration
	if (percentagePlayed > 90) {
		percentagePlayed = 90;
	}
	$('.player__timeline-elapsed').css('left', percentagePlayed + '%');
}


function fancyTimeFormat(time) {   
    // Hours, minutes and seconds
    var hrs = ~~(time / 3600);
    var mins = ~~((time % 3600) / 60);
    var secs = ~~time % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = "";

    if (hrs > 0) {
        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }

    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
}



function initLanguages() {
	// User has changed the language, se set the preference in a cookie and reload
	$('.welcome__language select, .player__header-language select').on('change', function () {
		Cookies.set('audio-tour-language', $(this).val(), { expires: 7 });
		location.reload();
	});
	
	// Set the dropdown to the current language
	/*if ( typeof Cookies.get('audio-tour-language') !== 'undefined' ) {
		var currentLanguage = Cookies.get('audio-tour-language');
		$('.welcome__language option[value="' + currentLanguage + '"], .player__header-language option[value="' + currentLanguage + '"]').attr( 'selected', 'selected' );
	}*/
}

function returnCurrentLanguage() {
	if ( typeof Cookies.get('audio-tour-language') !== 'undefined' ) {
		return Cookies.get('audio-tour-language');
	} else {
		return $('body').data('selected-language');
	}
}

function autoLoadFromHash() {
	var requestedTrack = parseInt(window.location.hash.replace('#', ''), 10);
	$('.player__title h1').text( decodeEntities(playerData[requestedTrack - 1 + playerDataOffset]["Title"]) );
	$('.player__track').text( requestedTrack );
	var player = $('#player')[0];
	player.load();
	setPlayerStatus('ready');
}

$('.player__header-language option[value="' + Cookies.get('audio-tour-language') + '"]').attr( 'selected', 'selected' )





// https://stackoverflow.com/questions/5796718/html-entity-decode
var decodeEntities = (function() {
  // this prevents any overhead from creating the object each time
  var element = document.createElement('div');

  function decodeHTMLEntities (str) {
    if(str && typeof str === 'string') {
      // strip script/html tags
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
      element.innerHTML = str;
      str = element.textContent;
      element.textContent = '';
    }

    return str;
  }

  return decodeHTMLEntities;
})();